<template>
  <div class="robitConfig">
    <el-tabs
      v-model="currentName"
    >
      <el-tab-pane
        v-if="wechatFlag"
        label="企业微信"
        name="wechat"
      >
        <div
          v-if="wechatFlag"
          class="con-tab-ejemplo">
          <wechat-list></wechat-list>
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-if="telegramFlag"
        label="Telegram"
        name="telegram"
      >
        <div
          v-if="telegramFlag"
          class="con-tab-ejemplo">
          <telegram-list></telegram-list>
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-if="larkFlag"
        label="Lark"
        name="lark"
      >
        <div
          v-if="larkFlag"
          class="con-tab-ejemplo">
          <lark-list></lark-list>
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-if="feishuFlag"
        label="Lark机器人"
        name="larkrobit"
      >
        <div
          v-if="feishuFlag"
          class="con-tab-ejemplo">
          <feishu-list></feishu-list>
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-if="dingdingFlag"
        label="钉钉"
        name="dingding"
      >
        <div
          v-if="dingdingFlag"
          class="con-tab-ejemplo">
          <dingding-list></dingding-list>
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-if="mt4Flag"
        label="MT4"
        name="mt4"
      >
        <div
          v-if="mt4Flag"
          class="con-tab-ejemplo">
          <mt4-list></mt4-list>
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-if="lineFlag"
        label="Line"
        name="line"
      >
        <div
          v-if="lineFlag"
          class="con-tab-ejemplo">
          <line-list></line-list>
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-if="qqFlag"
        label="QQ"
        name="qq"
      >
        <div
          v-if="qqFlag"
          class="con-tab-ejemplo">
          <qq-list></qq-list>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {queryPushTab} from "../../../api/user";
import mt4List from "@/components/sys/robitCofig/mt4List";
import dingdingList from "@/components/sys/robitCofig/dingdingList";
import telegramList from '@/components/sys/robitCofig/telegramList';
import larkList from "@/components/sys/robitCofig/larkList";
import wechatList from '@/components/sys/robitCofig/wechatList';
import feishuList from '@/components/sys/robitCofig/feishuList';
import lineList from "@/components/sys/robitCofig/lineList";
import qqList from '@/components/sys/robitCofig/qqList';
export default {
  name: "robitConfig",
  components: {
    wechatList,
    telegramList,
    larkList,
    feishuList,
    dingdingList,
    mt4List,
    lineList,
    qqList
  },
  data() {
    return {
      currentName: '',
      channelTypes: [],//渠道类型 1-微信公众号 2-telegram 3-Lark应用 4-企业微信 5-个人微信 6-Lark机器人 7-钉钉机器人 8-MT4通知 9-Line 10-QQ
    }
  },
  computed: {
    wechatFlag() {
      return this.channelTypes.includes(4) && this.isAuth('wx:qywxBotConfig:list');
    },
    telegramFlag() {
      return this.channelTypes.includes(2) && this.isAuth('wx:tgBotConfig:list');
    },
    larkFlag() {
      return this.channelTypes.includes(3) && this.isAuth('wx:larkAppConfig:list');
    },
    feishuFlag() {
      return this.channelTypes.includes(6) && this.isAuth('wx:larkBotConfig:list');
    },
    dingdingFlag() {
      return this.channelTypes.includes(7) && this.isAuth('wx:dingtalkBot:list');
    },
    mt4Flag() {
      return this.channelTypes.includes(8) && this.isAuth('wx:mt4Notifier:list');
    },
    lineFlag(){
      return this.channelTypes.includes(9) && this.isAuth('wx:lineGroup:list');
    },
    qqFlag(){
      return this.channelTypes.includes(10) && this.isAuth('wx:qqBotConfig:list');
    }
  },
  created(){
    this.getTabData();
  },
  methods:{
    assign(){
      const tab = [
        [this.wechatFlag, 'wechat'],
        [this.telegramFlag, 'telegram'],
        [this.larkFlag, 'lark'],
        [this.feishuFlag, 'larkrobit'],
        [this.dingdingFlag, 'dingding'],
        [this.mt4Flag, 'mt4'],
        [this.lineFlag, 'line'],
        [this.qqFlag, 'qq']
      ].find(item => item[0]);
      this.currentName = tab ? tab[1] : '';
    },
    getTabData(){
      queryPushTab().then((res) => {
        this.channelTypes = res.channelTypes;
        this.assign();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.robitConfig {
  background-color: #ffffff;
  padding: 20px;
  .con-tab-ejemplo {
    //padding-top: 10px;
  }

}
</style>
